module.exports = __webpack_public_path__ + "static/media/envase.5ab4d3c1.jpg";